import styles from './FJHeaderPanel.module.less';
import PropTypes from 'prop-types';
import LogoIcon from '../../../assets/svg/logo.svg?react';
import FJArrowIcon from '../../../assets/svg/button-pull-down.svg?react';
import FJStarIcon from '../../../assets/svg/star.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJDropDown from '../../../common/components/FJDropDown/FJDropDown';
import { RELEASE } from '../../../constants/FJEvnConstant';
import { useMemo, useCallback } from 'react';
import FJEvent from '../../../store/FJEvent';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';

const FJHeaderPanel = ({ headerDropDownData }) => {
    const curLanguage = FJLocalStore.currentTag();
    const isRelease = import.meta.env.MODE === RELEASE;

    const logoHrefUrl = useMemo(() => {
        if (isRelease) {
            return `https://www.flexclip.com/${curLanguage === 'en' ? '' : curLanguage + '/'}tools/`;
        }
        return `https://www.smartvideomaker.com/${curLanguage === 'en' ? '' : curLanguage + '/'}tools/`;
    }, [isRelease, curLanguage]);

    const mouseDownHeaderDropdown = useCallback(() => {
        FJEvent.dispatch(FJ_EVENT_TYPE.HIDE_SIDE_MODAL);
    }, []);

    return (
        <div className={styles.header_panel}>
            <a href={logoHrefUrl}>
                <LogoIcon />
            </a>
            <FJDropDown
                triggerDisplay='flex'
                placement='bottomLeft'
                overlay={
                    <div className={styles.ai_menu_box}>
                        <div className={styles.ai_menu_title}>
                            {FJLocalStore._('ai-tools')}
                            <FJStarIcon />
                        </div>
                        <div className={styles.ai_menu_list}>
                            {headerDropDownData.map((item, index) => (
                                <div
                                    key={index}
                                    className={styles.ai_menu_item}
                                    onClick={() => (location.href = item.href)}
                                >
                                    {<item.icon className={styles.ai_menu_icon} />}
                                    {FJLocalStore._(item.title)}
                                </div>
                            ))}
                        </div>
                    </div>
                }
                triggerClick={mouseDownHeaderDropdown}
            >
                <div className={styles.ai_menu_btn}>
                    <FJStarIcon className={styles.ai_menu_icon} />
                    <div className={styles.current_menu_title}>{FJLocalStore._('more-ai-tools')}</div>
                    <FJArrowIcon className={styles.arrow_icon} />
                </div>
            </FJDropDown>
        </div>
    );
};

FJHeaderPanel.propTypes = {
    headerDropDownData: PropTypes.array.isRequired,
    currentMenu: PropTypes.object.isRequired,
};

export default FJHeaderPanel;
